var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-table',{ref:"LTable",attrs:{"module-name":_vm.MODULE_NAME,"table-columns":_vm.tableColumns,"table-config-options":{endpoint: (_vm.MODULE_NAME + "/advisorStudents")}},scopedSlots:_vm._u([{key:"cell(dc_type)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.$langName(_vm.getDcType(data.value).name))+" ")]}},{key:"cell(organization)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.$langName(data.value.name))+" ")]}},{key:"cell(user)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.value.full_name)+" ")]}},{key:"cell(edu_lang)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.$langName(_vm.getEduLang(data.value).name))+" ")]}},{key:"cell(quarter)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.value.period.admission_year + '/' +data.value.quarter)+" ")]}},{key:"cell(direction)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.value.code + ' - ' + _vm.$langName(data.value.name))+" ")]}},{key:"cell(status)",fn:function(ref){
var data = ref.data;
return [_c('b-badge',{attrs:{"variant":_vm.getApplyDocumentStatusColor(data.value)}},[_vm._v(" "+_vm._s(_vm.$langName(_vm.getApplyDocumentStatus(data.value).name))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }